import { render, staticRenderFns } from "./OrthoPriorTreatments.vue?vue&type=template&id=7f5c1955&scoped=true"
import script from "./OrthoPriorTreatments.vue?vue&type=script&lang=js"
export * from "./OrthoPriorTreatments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c1955",
  null
  
)

export default component.exports